"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationCategory = void 0;
/**
 * This file was generated and subsequently committed to source via TypescriptUserFacingStringsGenerator.
 * Do not modify this file directly. If updates are required, update the utility as necessary and re-run it.
 */
var LocationCategory;
(function (LocationCategory) {
    LocationCategory["CloudStorage"] = "Cloud Storage";
    LocationCategory["Device"] = "Device";
    LocationCategory["Email"] = "Email";
    LocationCategory["Messaging"] = "Messaging";
    LocationCategory["MultiplePossibilities"] = "Multiple Possibilities";
    LocationCategory["SocialMedia"] = "Social Media";
    LocationCategory["SourceCodeRepository"] = "Source Code Repository";
    LocationCategory["Uncategorized"] = "Uncategorized";
    LocationCategory["Unknown"] = "Unknown";
    LocationCategory["BusinessIntelligenceTools"] = "Business Intelligence Tools";
    LocationCategory["CivilServices"] = "Civil Services";
    LocationCategory["CloudComputing"] = "Cloud Computing";
    LocationCategory["CodingTools"] = "Coding Tools";
    LocationCategory["ContractManagement"] = "Contract Management";
    LocationCategory["CrmTools"] = "CRM Tools";
    LocationCategory["DesignTools"] = "Design Tools";
    LocationCategory["ECommerce"] = "E-commerce";
    LocationCategory["FileConversionTools"] = "File Conversion Tools";
    LocationCategory["FinancialServices"] = "Financial Services";
    LocationCategory["HealthcareAndInsurance"] = "Healthcare & Insurance";
    LocationCategory["HrTools"] = "HR Tools";
    LocationCategory["ImageHosting"] = "Image Hosting";
    LocationCategory["ItServices"] = "IT Services";
    LocationCategory["JobListings"] = "Job Listings";
    LocationCategory["LearningPlatforms"] = "Learning Platforms";
    LocationCategory["MarketingTools"] = "Marketing Tools";
    LocationCategory["PdfManager"] = "PDF Manager";
    LocationCategory["PhotoPrinting"] = "Photo Printing";
    LocationCategory["ProductivityTools"] = "Productivity Tools";
    LocationCategory["ProfessionalServices"] = "Professional Services";
    LocationCategory["RealEstate"] = "Real Estate";
    LocationCategory["SalesTools"] = "Sales Tools";
    LocationCategory["SearchEngine"] = "Search Engine";
    LocationCategory["Shipping"] = "Shipping";
    LocationCategory["Software"] = "Software";
    LocationCategory["Travel"] = "Travel";
    LocationCategory["WebHosting"] = "Web Hosting";
    LocationCategory["Entertainment"] = "Entertainment";
    LocationCategory["FileTransferTools"] = "File Transfer Tools";
    LocationCategory["UtilityCompanies"] = "Utility Companies";
    LocationCategory["ReferenceTools"] = "Reference Tools";
    LocationCategory["NetworkStorage"] = "Network Storage";
    LocationCategory["AiTools"] = "AI Tools";
})(LocationCategory = exports.LocationCategory || (exports.LocationCategory = {}));
